import WJSON from '../libs/wjson';
import _ from 'lodash';

const UPDATE_AUTH_INFO  = "UPDATE_AUTH_INFO";
const CLEAN_AUTH_INFO   = "CLEAN_AUTH_INFO";

// dispatch function
export const updateAuthInfo = (newState) => ({ type : UPDATE_AUTH_INFO, newState })
export const cleanAuthInfo  = (newState) => ({ type : CLEAN_AUTH_INFO, newState })

const defaultAuthInfo = {
  authorization : null,
  roles         : [],
  permissions   : {},
  isLogin       : false,
}

export default (state = {}, action) => {
  
  let auth = WJSON.decode(localStorage.getItem('wauth')) || defaultAuthInfo
  
  auth = { ...defaultAuthInfo, ...auth, ...state}
  
  if (action.type === UPDATE_AUTH_INFO)
  {
    auth = { ...auth, ...action.newState }
    
    auth.isLogin = (auth.authorization !== null && (typeof auth.authorization === 'string') && auth.authorization.length > 0)
    
    localStorage.setItem('wauth', WJSON.encode(auth))

    return auth
  }

  if (action.type === CLEAN_AUTH_INFO )
  {
    localStorage.setItem('wauth', WJSON.encode(defaultAuthInfo))

    return defaultAuthInfo
  }
  
  return {...auth}
}

// 驗證測試用
function processDevPermissions() {
  const permissionGroup = ['user','model','dataset','service','docker-image','page','review']
  const actions = {
    view   : true,
    edit   : true,
    delete : false,
    review : true,
  };
  const devPermissions = {};

  permissionGroup.forEach(groupKey => {
    _.keys(actions).forEach(actionKey => {
      devPermissions[`${groupKey}:${actionKey}`] = actions[actionKey]
    })
  })
  return devPermissions
}


// WEBPACK FOOTER //
// ./src/reducers/auth.js